import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import Layout from "./Layout";
import PageContent from "./PageContent";
import React from "react";
import RichText from "./RichText";
import Text from "./Text";

function LegalPage({ pageData, navItems, globalData }) {
  const { title, content } = pageData;

  return (
    <Layout navItems={navItems} globalData={globalData}>
      <PageContent>
        <BoxWithGutter mt={[130, null, 160, null]} mb={[100, null, 200, null]}>
          <Text
            uppercase
            fontSize={[26, 26, 62, 62]}
            lineHeight={["32px", "32px", 1, 1]}
          >
            {title}
          </Text>
          <Box mt={[40, null, 100, null]} maxWidth={740} mx="auto">
            <RichText>{content}</RichText>
          </Box>
        </BoxWithGutter>
      </PageContent>
    </Layout>
  );
}

export default LegalPage;
